export default {"src":"/_next/static/media/calculator-ico.9ec1c750.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};